import { useState } from 'react'
import { useDispatch } from 'react-redux'

import { setUser } from '../../redux/actions/user'
import { updateProfile } from '../../api/account'

import styles from './AccountSettings.module.css'

const OPTIONS = [
  ['user_joined_group', 'Someone joins one of my groups'],
  ['recipe_published_to_group', 'A new recipe is added to one of my groups'],
  ['comment_on_my_recipe', 'Someone comments on my recipe'],
  ['reply_to_my_comment', 'Someone replies to my comment'],
  ['comment_in_my_groups', 'Any new comment in my groups'],
]

// Each switch saves straight away
const NotificationsSection = ({ user }) => {
  const dispatch = useDispatch()
  const [on, setOn] = useState(user.notifications || [])
  const [error, setError] = useState('')

  const toggle = (key) => {
    const before = on
    const next = on.includes(key) ? on.filter((k) => k !== key) : [...on, key]
    setOn(next)
    setError('')
    updateProfile({ notifications: next })
      .then(({ data }) => dispatch(setUser({ ...user, ...data })))
      .catch(() => {
        setOn(before)
        setError('That change did not save. Please try again.')
      })
  }

  return (
    <section id="notifications" className={styles.card} aria-labelledby="notifications-title">
      <h2 id="notifications-title" className={styles.h2}>
        Email notifications
      </h2>
      <p className={styles.lead}>
        Choose what Morsel emails you about. Order and account emails always come.
      </p>
      {OPTIONS.map(([key, label]) => {
        const checked = on.includes(key)
        return (
          <div key={key} className={styles.notifRow}>
            <span id={`n-${key}`}>{label}</span>
            <button
              type="button"
              role="switch"
              aria-checked={checked}
              aria-labelledby={`n-${key}`}
              className={`${styles.switch} ${checked ? styles.switchOn : ''}`}
              onClick={() => toggle(key)}
            >
              <span />
            </button>
          </div>
        )
      })}
      {error ? <p className={styles.error}>{error}</p> : null}
    </section>
  )
}

export default NotificationsSection
